import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { CustomersReportsPgComponent } from './customers-reports-pg/customers-reports-pg.component';

const routes: Routes = [
  {
    path: '',
    component: CustomersReportsPgComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CustomerReportsPgsRoutingModule { }
